import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-License-Identifier: AGPL-3.0-or-later
import { useEffect, useState } from 'react';
import { Command } from 'cmdk';
import { Search } from 'lucide-react';
import { Dialog } from './Dialog.js';
function CommandPaletteRoot(props) {
    const { open, onOpenChange, placeholder = 'Type a command or search…', emptyMessage = 'No results.', children, } = props;
    // Reset the search query each time the palette closes — a stale
    // filter on reopen surprises users and hides items that were there
    // the moment before.
    const [query, setQuery] = useState('');
    useEffect(() => {
        if (!open)
            setQuery('');
    }, [open]);
    return (_jsx(Dialog, { open: open, onOpenChange: onOpenChange, children: _jsx(Dialog.Content, { width: "36rem", showClose: false, "aria-label": "Command palette", "data-command-palette": "true", children: _jsxs(Command, { label: "Command palette", "data-command-root": "true", children: [_jsxs("div", { "data-command-input-wrap": "true", children: [_jsx(Search, { "aria-hidden": "true", size: 16, "data-command-input-icon": "true" }), _jsx(Command.Input, { autoFocus: true, placeholder: placeholder, value: query, onValueChange: setQuery, "data-command-input": "true" })] }), _jsxs(Command.List, { "data-command-list": "true", children: [_jsx(Command.Empty, { "data-command-empty": "true", children: emptyMessage }), children] })] }) }) }));
}
function CommandPaletteGroup(props) {
    return (_jsx(Command.Group, { heading: props.heading, "data-command-group": "true", children: props.children }));
}
function CommandPaletteAction(props) {
    const { label, keywords, icon, shortcut, onSelect } = props;
    return (_jsxs(Command.Item, { value: [label, ...(keywords ?? [])].join(' '), onSelect: onSelect, "data-command-item": "true", children: [icon !== undefined ? (_jsx("span", { "data-command-item-icon": "true", "aria-hidden": "true", children: icon })) : null, _jsx("span", { "data-command-item-label": "true", children: label }), shortcut !== undefined ? _jsx("kbd", { "data-command-item-shortcut": "true", children: shortcut }) : null] }));
}
const CommandPaletteFn = CommandPaletteRoot;
CommandPaletteFn.Group = CommandPaletteGroup;
CommandPaletteFn.Action = CommandPaletteAction;
export const CommandPalette = CommandPaletteFn;
/**
 * Mount once inside a route that already has access to whatever the
 * palette's actions need (router, theme toggle, etc.). Toggles the
 * caller's `open` state on Cmd+K / Ctrl+K. Pass `enabled=false` to
 * suppress the binding (e.g. on patient routes) without unmounting.
 */
export function useCommandPaletteShortcut(setOpen, enabled = true) {
    useEffect(() => {
        if (!enabled)
            return undefined;
        const onKey = (e) => {
            const isToggle = (e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k';
            if (!isToggle)
                return;
            e.preventDefault();
            // Functional update via closure — `setOpen` may be from useState,
            // in which case the caller passes `(v) => !v`. We can't infer
            // that here, so the simplest reliable API is to toggle from the
            // outside; expose this as documentation rather than try to be
            // clever inside the hook.
            setOpen(true);
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [setOpen, enabled]);
}
//# sourceMappingURL=CommandPalette.js.map